class CollectionDescriptionComponent extends HTMLElement {
  #expanded = false;
  #toggleButton;
  #excerpt;
  #fullContent;

  connectedCallback() {
    this.#toggleButton = this.querySelector('[ref="toggleButton"]');
    this.#excerpt = this.querySelector('[ref="excerpt"]');
    this.#fullContent = this.querySelector('[ref="fullContent"]');

    if (!this.#toggleButton || !this.#excerpt || !this.#fullContent) return;

    this.#toggleButton.addEventListener('click', this.#onToggle);
  }

  disconnectedCallback() {
    this.#toggleButton?.removeEventListener('click', this.#onToggle);
  }

  #onToggle = () => {
    this.#expanded = !this.#expanded;
    this.dataset.expanded = this.#expanded ? 'true' : 'false';
    this.#toggleButton.setAttribute('aria-expanded', this.dataset.expanded);

    if (this.#expanded) {
      this.#excerpt.classList.add('hidden');
      this.#fullContent.classList.remove('hidden');
      return;
    }

    this.#excerpt.classList.remove('hidden');
    this.#fullContent.classList.add('hidden');
  };
}

if (!customElements.get('collection-description-component')) {
  customElements.define('collection-description-component', CollectionDescriptionComponent);
}
